export default __webpack_public_path__ + "8551e8d16a72c05f4b801416e150aa19.png";